import React, { useState, useEffect } from 'react';
import RichTable from '../components/richTable/RichTable.jsx'
import tableHelpers from '../helpers/TableHelpers.js'
import backtestResultsHelpers from '../helpers/BacktestResultsHelpers.js'
import TradeInstructions from '../trades/TradeInstructions.js';
import { Link } from 'react-router-dom'
import ActionResult from '../components/ActionResult.js';
import { useNavigate } from 'react-router-dom'
import AccountHistoryChart from './AccountHistoryChart.js';

function AccountSummaryCard(props) {
    const navigate = useNavigate()

    const [isUpdatingAccountValue, setIsUpdatingAcccountValue] = useState(false);
    const [accountValue, setAccountValue] = useState(props.accountValue);
    const [result, setResult] = useState(null);

    useEffect(() => {
        setAccountValue(props.accountValue);
    }, [props.accountValue]);

    function getAccountInfo() {

        let netProfit = backtestResultsHelpers.getReturnSince(props.performanceResults, new Date(props.startDate), false);

        return [{
            name: props.accountName,
            planName: props.planName,
            accountValue: props.accountValue,
            todaysChange: props.todaysChange,
            netProfit: netProfit,
            todaysTrades: props.todaysTrades
        }];
    }

    function todaysTradesFormatter(cell, row) {
        return <TradeInstructions accountId={props.accountId}
            isOptions={props.isOptions}
            userId={props.userId}
            hideHeader={true}
            hideProfit={true}
            planId={props.planId}
            accountValue={props.accountValue}
            trades={props.todaysTrades}
            popupLocation="left center"
            brokerage={props.brokerage}
            brokerageHref={props.brokerageHref}
            brokerageAuthenticated={props.brokerageAuthenticated}
            mobileView={props.mobileView}
            role={props.role}
        />
    }

    async function onUpdateAccountValue() {

        console.log("onUpdateAccountValue")
        const url = "/api/accountValue?userId=" + props.userId + "&accountId=" + props.accountId + "&balance=" + accountValue;
        let result = await fetch(url, { method: "post" })
        setResult(result);
        setIsUpdatingAcccountValue(false);

        if (props.onAccountValueUpdated)
            props.onAccountValueUpdated(props.accountId, accountValue);
    }

    async function onSyncAccountWithBrokerage() {

        console.log("onUpdateAccountValue")
        const url = "/api/accountSyncWithBrokerage?userId=" + props.userId + "&accountId=" + props.accountId;
        let result = await (await (await fetch(url, { method: "post" }))).json()
        setResult(result);
        if (result.success) {
            if (props.onAccountValueUpdated)
                props.onAccountValueUpdated(props.accountId, result.value);
        } else {

        }
        console.log(result);
    }

    function onAccountSelected() {
        console.log("onAccountSelected", props.accountId)
        if (props.onAccountSelected) {
            props.onAccountSelected(props.accountId);
            navigate('/overview')
        }
    }

    function accountValueFormatter(cell, row) {
        if (isUpdatingAccountValue) {
            return (
                <>
                    <input type="text" defaultValue={props.accountValue} onChange={(e) => setAccountValue(e.target.value)} /><Link reloadDocument onClick={() => onUpdateAccountValue()}>Save</Link>
                </>
            )
        } else {
            return (
                <>
                    {props.hideValue ? "****" : tableHelpers.moneyFormatterNoCents(cell, row)}&nbsp;<Link className={"small-text"} onClick={() => setIsUpdatingAcccountValue(true)}>(Update)</Link>
                    {props.brokerage ? <Link className={"small-text"} onClick={() => onSyncAccountWithBrokerage()}>(Sync)</Link> : null}
                </>
            );
        }
    }

    function getRowClassName(row) {
        return "analytics_hidden"
    }

    function accountNetProfitFormatter(cell, row) {
        return (
            <>
                <b>{tableHelpers.percentFormatter(cell, row)}</b>
                <AccountHistoryChart accountId={props.accountId} userId={props.userId} />
            </>
        )
    }

    return (
        <div>

            <h5>
                {props.accountName + " (" + props.planName + ")"}  (<Link reloadDocument to={"/overview"} onClick={() => onAccountSelected()}>Overview</Link>)

                <RichTable data={getAccountInfo()} className="table-condensed" rowClassName={getRowClassName} mappers={[
                    { title: 'Account Value', field: 'accountValue', formatter: accountValueFormatter, width: '25%' },
                    { title: `Total P/L`, field: 'netProfit', formatter: accountNetProfitFormatter, width: '25%' },
                    { title: `Today's Change`, field: 'todaysChange', formatter: tableHelpers.percentChangeFormatter, width: '25%' },
                    { title: `Today's Trades`, field: 'todaysTrades', formatter: todaysTradesFormatter, width: '25%' },
                ]} />
            </h5>

            <ActionResult result={result} />
        </div >);
}

export default AccountSummaryCard;